export default __webpack_public_path__ + "static/media/letsignit.03f1f65f.png";